var core = module.exports = {version: '1.2.6'};
if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef


//////////////////
// WEBPACK FOOTER
// ../node_modules/core-js/modules/$.core.js
// module id = 24
// module chunks = 0